module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-09-ed7f5c6343fc2240f8718469035100bd.webp";